module.exports = __webpack_public_path__ + "img/first-outer.b03b082d.svg";